import React, { useState } from "react";
import { ReportFormContainer } from "./ReportFormContainer";
import { Report } from "./Report/Report";
import { Api } from "api/api";
import { toast } from "react-toastify";

export const CompanySearch = ({ mobile, recaptchaRef }) => {
  const [reportResponse, setReportResponse] = useState();
  const [isLoading, setIsLoading] = useState();

  const submit = async (code) => {
    const token = await recaptchaRef.current.executeAsync();
    if (token) {
      try {
        setIsLoading(true);
        const res = await Api.GetReport(code);
        if (res) {
          setReportResponse(res);
        }
      } catch (err) {
        toast.error("Neteisingas įmonės kodas.", { toastId: code });
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      {reportResponse ? (
        <Report data={reportResponse} />
      ) : (
        <ReportFormContainer submit={submit} mobile={mobile} isLoading={isLoading} />
      )}
    </>
  );
};
